import axios from '../axiosInstance';

export const StatisticsApi = () => ({
  get: <T = any>(url: string, params?: Record<string, any>) =>
    axios.get<T>(url, { params }),
});